export const defaultPassphrase = 'cloudpack';
